import React from 'react';
import { translate } from 'react-i18next';
import {Card, CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ShopCreate from './ShopCreate';
import AddUser from './AddUser';

class ShopList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shopkeepers: [],
      dialogShopCreateOpen: false,
      dialogAddUserOpen: false,
      shopkeeperId: ''
    };
  }
  componentDidMount = () => {
    const {firebase} = this.props;
    this.shopkeeperRef = firebase.database().ref('shopkeepersList/').orderByValue();
    this.shopkeeperRef.on('child_added', this.addShopkeeper);
  }
  componentWillUnmount = () => {
    if (this.shopkeeperRef) {
      this.shopkeeperRef.off('child_added');
    }
  }
  addShopkeeper = (data) => {
    let shopkeeper = {
      key: data.key,
      name: data.val()
    };
    const currentShopkeepers = this.state.shopkeepers.slice();
    currentShopkeepers.push(shopkeeper);
    this.setState({shopkeepers: currentShopkeepers});
  }
  handleShopCreateOpen = () => this.setState({dialogShopCreateOpen: true});
  handleShopCreateClose = () => this.setState({dialogShopCreateOpen: false});

  handleAddUserOpen = (shopkeeperId) => this.setState({dialogAddUserOpen: true, shopkeeperId});
  handleAddUserClose = () => this.setState({dialogAddUserOpen: false});

  render() {
    const {t} = this.props;
    const shopkeepers = this.state.shopkeepers.map((shopkeeper) => (
      <ListItem key={shopkeeper.key}
        primaryText={shopkeeper.name}
        rightIconButton={<IconMenu
        iconButtonElement={<IconButton touch={true}><MoreVertIcon /></IconButton>}
        useLayerForClickAway={true}
        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
        targetOrigin={{horizontal: 'right', vertical: 'top'}}>
          <MenuItem
            primaryText={t('shop.addUser')} onTouchTap={() => this.handleAddUserOpen(shopkeeper.key)}/>
        </IconMenu>}
        />
    ));

    return (
        <Card className='cardStyle'>
          <Toolbar>
            <ToolbarGroup>
              <ToolbarTitle text={t('shopkeepers')} />
            </ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              <FlatButton label={t('shop.create')} primary={true} onTouchTap={this.handleShopCreateOpen} />
            </ToolbarGroup>
          </Toolbar>
          <CardText style={{textAlign: 'left', position: 'relative'}}>
            <List>
              {shopkeepers}
            </List>
          </CardText>
          <ShopCreate open={this.state.dialogShopCreateOpen} handleClose={this.handleShopCreateClose}/>
          <AddUser open={this.state.dialogAddUserOpen} handleClose={this.handleAddUserClose} shopkeeperId={this.state.shopkeeperId}/>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ShopList);



// WEBPACK FOOTER //
// ./src/Admin/ShopList.js